<template>
  <div class="container Pos-r" v-if="userInfo">
    <div class="title">基本信息</div>
    <Row type="flex" :gutter="10" justify="center">
      <div style="width:400px">
        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">昵称：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo.user.nickname }}</div>
          </Col>
        </Row>
        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">姓名：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo.user.name }}</div>
          </Col>
        </Row>
        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">性别：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo.user.gender }}</div>
          </Col>
        </Row>
        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">手机号：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo.user.mobileMask }}</div>
          </Col>
        </Row>

        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">我的公司：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo && userInfo.company && userInfo.company.name }}</div>
          </Col>
        </Row>
        <Row class="item-wrap margin-bottom20" type="flex" align="middle">
          <Col span="10" class="item-title">我的职务：</Col>
          <Col span="14">
            <div class="item-value">{{ userInfo && userInfo.duty }}</div>
          </Col>
        </Row>
      </div>
        <div class="avatar-wrap ">
          <img
            :src="userInfo && userInfo.user && userInfo.user.avatarUrl ? userInfo.user.avatarUrl : '//weapp-cdn.gongjiayun.cn/avatar.png'"
            alt
          />
        </div>
    </Row>

    <div class="btn-wrap">
      <Button type="primary" @click="goEdit">编辑</Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$axios.request({ url: 'front/v1/company-user/myInfo' }).then(res => {
        this.userInfo = res.data;
      });
    },
    goEdit() {
      this.$router.push({
        name: 'ziliao-edit'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 40px 0;
  .editor-wrapper {
    width: 350px;
  }
}
.title {
  text-align: center;
  color: #363e4f;
  font-size: 16px;
  margin-bottom: 20px;
}
.item-wrap {
  .item-title {
    text-align: right;
    padding-right: 10px;
  }
  /deep/ .fileinput-btn {
    padding: 5px 22px;
    .ivu-icon {
      font-size: 30px;
    }
  }
}
.btn-wrap{
  text-align: center;
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.avatar-wrap {
  left: 756px;
  img {
    border: 1px solid #ccc;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
}
</style>
